"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styled = require("./styled");
var _materialIconsReact = _interopRequireDefault(require("material-icons-react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = require("styled-components");
var _react = _interopRequireWildcard(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = ["color", "display", "icon", "margin", "size", "zIndex"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
const MaterialIcon = _ref => {
  let {
      color: propColor,
      display = 'flex',
      icon = 'more_horiz',
      margin,
      size = 24,
      zIndex
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const {
    textColor
  } = (0, _styledComponents.useTheme)();
  const color = propColor !== null && propColor !== void 0 ? propColor : textColor;
  const iconRef = (0, _react.useRef)();
  (0, _react.useEffect)(() => {
    const i = iconRef.current.querySelector('i');
    i.innerHTML = icon;
  }, [icon]);
  (0, _react.useEffect)(() => {
    const i = iconRef.current.querySelector('i');
    if (!!color || !!size) {
      i.setAttribute('style', "\n                ".concat(color ? "color: ".concat(color, ";") : '', "\n                ").concat(size ? "font-size: ".concat(size, "px;") : '', "\n            "));
    }
  }, [color, size]);
  const containerProps = {
    display,
    margin,
    zIndex
  };
  const iconProps = _objectSpread({
    color,
    icon,
    size
  }, props);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styled.Container, _objectSpread(_objectSpread({
    ref: iconRef
  }, containerProps), {}, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialIconsReact.default, _objectSpread({}, iconProps))
  }));
};
MaterialIcon.propTypes = {
  color: _propTypes.default.string,
  display: _propTypes.default.string,
  icon: _propTypes.default.string,
  size: _propTypes.default.number,
  zIndex: _propTypes.default.number
};
var _default = exports.default = MaterialIcon;